var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../../atoms/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/avatar/avatar.js';
import '@shoelace-style/shoelace/dist/components/divider/divider.js';
import '@shoelace-style/shoelace/dist/components/skeleton/skeleton.js';
import '../../atoms/vertical-layout/vertical-layout.js';
import '../../atoms/horizontal-layout/horizontal-layout.js';
import '../../atoms/icon/icon.js';
import '../../atoms/icon-button/icon-button.js';
import '../../atoms/badge/badge.js';
import '../../watching-count/watching-count.js';
import '../function-badge/function-badge.js';
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { when } from 'lit/directives/when.js';
import { getFullName, getInitials } from '../../helpers/nameHelpers.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import { watch } from '../../internal/watch.js';
import styles from './participant-card.styles.js';
const iconStyle = '--icon-size:1.8em; --icon-fill-color: var( --sgdf-color-light);';
export const iconByMode = {
    link: 'eye',
    detail: 'id-card',
    'check-in': 'signature',
    interview: 'handshake',
    validation: 'feather',
};
/**
 * @summary Short summary of a participant.
 * @status experimental
 * @since 1.0
 *
 * @dependency sgdf-horizontal-layout
 * @dependency sgdf-vertical-layout
 * @dependency sgdf-icon
 * @dependency sgdf-icon-button
 * @dependency sgdf-badge
 * @dependency sgdf-function-badge
 * @dependency sl-avatar
 * @dependency sl-divider
 *
 * @event sgdf-participant:navigate - Emitted on card click.
 */
class SgdfParticipantCard extends SgdfElement {
    constructor() {
        super(...arguments);
        this.skeleton = false;
        this.mode = 'link';
        this.highlight = false;
    }
    onClick() {
        this.emit('sgdf-participant:navigate', {
            detail: {
                participantId: this.participant.id,
                action: this.mode,
            },
        });
    }
    onHighlighted() {
        var _a;
        if (this.highlight) {
            (_a = this.element) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'instant',
            });
        }
    }
    render() {
        var _a, _b;
        return html `<div
            class=${classMap({
            'participant-item': true,
            highlight: this.highlight,
        })}
            @click=${this.onClick}
        >
            <sgdf-horizontal-layout
                style="align-items: center; justify-content: space-between; width: 100%;"
                theme="spacing"
            >
                <sgdf-horizontal-layout
                    style="align-items: center;  width: 100%; overflow: hidden;"
                    theme="spacing"
                >
                    <sl-avatar
                        initials=${ifDefined(!this.skeleton
            ? getInitials(this.participant)
            : undefined)}
                        image=${ifDefined(this.participant.avatar_available
            ? this.participant.avatar_url
            : this.participant.user_avatar_available
                ? this.participant.user_avatar_url
                : undefined)}
                    ></sl-avatar>
                    <sgdf-vertical-layout
                        style="gap: 0.3em; width: 100%; overflow: hidden;"
                    >
                        <sgdf-horizontal-layout
                            theme="spacing"
                            style="justify-content: space-between; width: 100%; align-items: center; overflow: hidden;"
                        >
                            <h3 class="name">
                                ${when(!this.skeleton, () => getFullName(this.participant), () => html `<sl-skeleton
                                            style="height: 16px; width: 100px;"
                                        ></sl-skeleton>`)}
                                <sgdf-icon-button
                                    class="external-link"
                                    name="square-up-right"
                                    href=${ifDefined(this.skeleton
            ? undefined
            : this.participant.link)}
                                    target="_blank"
                                    @click=${(e) => {
            e.stopPropagation();
        }}
                                ></sgdf-icon-button>
                            </h3>
                            ${when(((_a = this.participant.observation_count) !== null && _a !== void 0 ? _a : 0) > 0, () => html `<sgdf-watching-count
                                        count=${this.participant.observation_count}
                                    ></sgdf-watching-count>`)}
                        </sgdf-horizontal-layout>
                        <sgdf-horizontal-layout
                            style="align-items: center;  width: 100%; overflow: hidden;"
                        >
                            <sgdf-function-badge
                                branche=${ifDefined((_b = this.participant.branche) !== null && _b !== void 0 ? _b : undefined)}
                            ></sgdf-function-badge>
                            ${when(this.participant.daily_task_team, () => {
            var _a, _b;
            return html `
                                    <sl-divider
                                        vertical
                                        style="height: 1rem;"
                                    ></sl-divider>
                                    <div class="team">
                                        <sgdf-icon
                                            name="user-group"
                                            style="--icon-fill-color: var( --sgdf-color-light);"
                                        ></sgdf-icon>
                                        <sgdf-badge
                                            color=${ifDefined((_a = this.participant.daily_task_team) === null || _a === void 0 ? void 0 : _a.color)}
                                            >${(_b = this.participant.daily_task_team) === null || _b === void 0 ? void 0 : _b.label}</sgdf-badge
                                        >
                                    </div>
                                `;
        })}
                        </sgdf-horizontal-layout>
                    </sgdf-vertical-layout>
                </sgdf-horizontal-layout>
                ${this.displayActionIcon()}
            </sgdf-horizontal-layout>
        </div>`;
    }
    displayActionIcon() {
        var _a;
        let mode_icon = html ``;
        if (typeof ['link', 'check-in', 'interview', 'validation'].find(e => e === this.mode) === 'string') {
            mode_icon = html ` <sgdf-icon-button
                name=${ifDefined((_a = iconByMode[this.mode]) !== null && _a !== void 0 ? _a : undefined)}
                style=${iconStyle}
            ></sgdf-icon-button>`;
        }
        return html `<div class="action-icon">${mode_icon}</div>`;
    }
}
SgdfParticipantCard.styles = styles;
export default SgdfParticipantCard;
__decorate([
    property({ type: Object, reflect: true })
], SgdfParticipantCard.prototype, "participant", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfParticipantCard.prototype, "skeleton", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantCard.prototype, "mode", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfParticipantCard.prototype, "highlight", void 0);
__decorate([
    query('.highlight')
], SgdfParticipantCard.prototype, "element", void 0);
__decorate([
    watch('highlight')
], SgdfParticipantCard.prototype, "onHighlighted", null);
//# sourceMappingURL=participant-card.component.js.map